import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

/**
 * Service d'utilisateur
 */
@Injectable({
  providedIn: 'root'
})
export class UtilisateurService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Obtenir l'utilisateur courant
     */
    obtenirUtilisateurCourant() {
        return this.http.get(`api/utilisateur/utilisateurcourant`).pipe(map(retour => { return retour; }));
    }

    /**
     * Obtenir un utilisateur par son ID
     * @param id
     */
    obtenirUtilisateur(id: number) {
        let httpParams = new HttpParams().set('Id', id.toString());
        let options = {
            params: httpParams
        };
        return this.http.get(`api/utilisateur/obtenirutilisateur`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Lister les utilisateurs du fournisseur
     * @param codeFournisseur
     * @param indice
     * @param nbElements
     */
    listerUtilisateursParFournisseur(codeFournisseur: string, indice: number, nbElements: number) {
        let httpParams = new HttpParams()
            .set('CodeFournisseur', codeFournisseur)
            .set('Pagination.Indice', indice.toString())
            .set('Pagination.NombreElements', nbElements.toString());
        let options = {
            params: httpParams
        };
        return this.http.get(`api/utilisateur/listerutilisateursparfournisseur`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Changer de fournisseur courant
     * @param codeFournisseur
     */
    changerFournisseurCourant(codeFournisseur: string) {
        let httpParams = new HttpParams().set('CodeFournisseur', codeFournisseur);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/utilisateur/changerfournisseurcourant`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Obtenir les informations � partir du token
     * @param codeFournisseur
     */
    obtenirInformationsToken(token: string) {
        let httpParams = new HttpParams().set('Token', token);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/utilisateur/obtenirinformationstoken`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Enregistrer le mot de passe par token
     */
    enregistrerMotDePasseToken(motDePasse: string, token: string) {
        let modele = {
            MotDePasse: motDePasse,
            Token: token
        };
        return this.http.post(`api/utilisateur/enregistrermotdepassetoken`, modele).pipe(map((retour: any): any => { return retour }));
    }

    obtenirCampagnesActives() {
        return this.http.get(`api/confighome/obtenircampagnesactives`).pipe(map((retour: any): any => { return retour }));
    }
}
